import { Component, OnInit, Inject } from '@angular/core';
import * as firebase from 'firebase';
import { AuthService } from '../services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DateService } from '../services/date.service';
import * as moment from 'moment'
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as internal from 'events';
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(private dateService: DateService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe) { }
  isAuth: boolean;
  name: string;
  admin: any;
  setDate = false
  signUpForm: FormGroup;
  date_start: string = localStorage.getItem('date_start');
  date_end: string = localStorage.getItem('date_end');
  setGraph
  anotherVar: String = '';
  realTime
  start
  services = ['Marketing', 'Dev', 'Opération','Prod']
  userService
  end
  page: string
  right: number = 0
  activeTab: string
  view: string = ""
  rightView: number = -250;
  rightOption: number = -250;
  interval = this.dateService.getInterval();
  shopId: string = "1";
  ngOnInit() {
    localStorage.setItem('realTime', '0');
    localStorage.setItem('settings', 'hide');
    localStorage.setItem('shopId', '1');
    this.dateService.changeVar.subscribe(message => this.anotherVar = message)
    firebase.auth().onAuthStateChanged(
      (user) => {
        if (user) {
          this.authService.isAdmin().then((name) => {
            this.admin = name
          }).then(() => {
            var id = firebase.auth().currentUser.uid;
            var ref = firebase.database().ref("users");
            let now = new Date();
            let date_end = this.datepipe.transform(now,'yyyy-MM-dd');
            now.setDate(now.getDate() - 1);
            let date_start = this.datepipe.transform(now,'yyyy-MM-dd');
            this.date_start = date_start;
            this.date_end = date_end;
            localStorage.setItem('date_start', this.date_start);
            localStorage.setItem('date_end', this.date_end);
            this.initForm()
            ref.orderByKey().equalTo(id).on("child_added", (snapshot) => {
              if (snapshot.val().actif == true) {
                this.isAuth = true;
                this.authService.getService().then(() => {
                  this.userService = localStorage.getItem('service');
                  localStorage.setItem('admin_service', (localStorage.getItem('service')));
                })
              }
            });
          }).then(() => {
            this.page = localStorage.getItem('page')
          })

        } else {
          this.admin = false;
          this.isAuth = false;
        }
      }
    );


  }

  onSignOut() {
    this.authService.signOutUser();
  }

  showDate() {
    if (this.setDate == false) {
      this.setDate = true;
    }
    else {
      this.setDate = false
    }
  }

  initForm() {
    this.signUpForm = this.formBuilder.group({
      date_start: [this.date_start, [Validators.required]],
      date_end: [this.date_end, [Validators.required]],
    });

  }

  onSubmit() {
    var start = moment(this.start).format('YY-MM-DD')
    var end = moment(this.end).format('YY-MM-DD')
    this.dateService.getDate(start, end).then(() => {
      this.date_start = localStorage.getItem('date_start');
      this.date_end = localStorage.getItem('date_end');
      this.initForm
    })
    this.myFunction()
  }

  tt = 0
  myFunction() {
    this.dateService.changeMyVar(' ' + this.tt++); // update variable
  }


  setRealTime() {
    localStorage.setItem('settings', 'hide');
    localStorage.setItem('realTime', '1')
    this.sidebar(false,'')
    this.realTime = null;
    this.dateService.getDate(moment().format('YY-MM-DD'), moment().format('YY-MM-DD')).then(() => {
      this.date_start = localStorage.getItem('date_start');
      this.date_end = localStorage.getItem('date_end');
      this.initForm
      this.myFunction()
    })
    this.realTime = this.realTime ? clearInterval(this.realTime) : setInterval(() => {
      this.dateService.getDate(moment().format('YY-MM-DD'), moment().format('YY-MM-DD')).then(() => {
      this.date_start = localStorage.getItem('date_start');
      this.date_end = localStorage.getItem('date_end');
      this.initForm
      this.myFunction()
    })
  }, this.interval)
  }

  selectDate(period) {
    this.realTime ? clearInterval(this.realTime) : "";
    localStorage.setItem('realTime', '0');
    localStorage.setItem('settings', 'hide');
    this.sidebar(false,'')
    switch (period) {
      case 'week':
        var start = moment().subtract(1, 'week').format('YY-MM-DD')
        break;
      case 'month':
        var start = moment().subtract(1, 'month').format('YY-MM-DD')
        break
      case 'year':
        var start = moment().subtract(1, 'year').format('YY-MM-DD')
        break
      default:
        break;
    }
    this.dateService.getDate(start, moment().format('YY-MM-DD')).then(() => {
      this.date_start = localStorage.getItem('date_start');
      this.date_end = localStorage.getItem('date_end');
      this.initForm
      this.myFunction()
    })
  }

  switchIdShop(){
    if(this.shopId == '1'){
      this.shopId = "2";
    }else{
      this.shopId = "1";
    }
    localStorage.setItem('shopId', this.shopId);
    this.myFunction()
    this.initForm
  }

  test(e) {
    localStorage.setItem('admin_service', (e.value));
    this.myFunction();
  }

  getPage(page: string) {
    localStorage.setItem('settings', 'hide');
    this.sidebar(false,'')
    this.page = page
  }

  async loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = false;
    body.appendChild(script);
  }

  sidebar(bool, type) {
    bool == true ? this.right = 250 : this.right = 0
    this.view = type;
    switch (type) {
      case "view":
        localStorage.setItem('settings', 'hide');
        this.rightOption = -250;
        this.rightView = 0;
        break;
      case "graph":
        this.rightOption = -250;
        this.rightView = -250;
        localStorage.setItem('settings', 'show');
        break;
      case "option":
        localStorage.setItem('settings', 'hide');
        this.rightView = -250;
        this.rightOption = 0;
        break;
      default:
        localStorage.setItem('settings', 'hide');
        this.rightView = -250;
        this.rightOption = -250;
        break;
    }
    this.myFunction();
  }

}
